(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vva-clearance-banner"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('vv-clearance-banner')){
  customElements.define('vv-clearance-banner',class extends HTMLElement{
    connectedCallback(){
      const bar=this.querySelector('.vv-clearance-bar');
      if(!bar)return;
      const update=()=>{this.style.height=Math.ceil(bar.getBoundingClientRect().height)+'px';};
      update();
      this.observer=new ResizeObserver(update);
      this.observer.observe(bar);
    }
    disconnectedCallback(){if(this.observer)this.observer.disconnect();}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vva-package-popup"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('vv-package-popup')){
 customElements.define('vv-package-popup',class extends HTMLElement{
  connectedCallback(){
   this.dialog=this.querySelector('dialog');
   this.key='vv-package-promo-sep-2026';
   this.closeButtons=this.querySelectorAll('.vva-package-popup-close,.vva-package-popup-dismiss');
   this.close=()=>{this.dialog.close();try{sessionStorage.setItem(this.key,'dismissed')}catch(e){}};
   this.closeButtons.forEach(button=>button.addEventListener('click',this.close));
   this.dialog.addEventListener('click',event=>{if(event.target===this.dialog)this.close()});
   let dismissed=false;
   try{dismissed=sessionStorage.getItem(this.key)==='dismissed'}catch(e){}
   if(!dismissed)setTimeout(()=>{if(!this.dialog.open)this.dialog.showModal()},1400);
  }
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vva-sale-countdown"] && !Shopify.designMode) return;
  try {
    (function(){
const wrap=document.getElementById('vv-package-promo');
if(!wrap)return;
const clock=wrap.querySelector('.vv-sale-clock');
const deadline=Date.parse(clock.dataset.end);
let interval;
function tick(){
const remaining=Math.max(0,Math.floor((deadline-Date.now())/1000));
if(!remaining){wrap.remove();clearInterval(interval);return;}
const values={days:Math.floor(remaining/86400),hours:Math.floor(remaining/3600)%24,minutes:Math.floor(remaining/60)%60,seconds:remaining%60};
Object.entries(values).forEach(([unit,value])=>{clock.querySelector('[data-unit="'+unit+'"]').textContent=String(value).padStart(2,'0');});
}
tick();
if(wrap.isConnected)interval=setInterval(tick,1000);
})();
  } catch(e) { console.error(e); }
})();

})();
